import {
  QueryKey,
  useMutation,
  UseMutationOptions,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { ApiErrorResponse, ApiResponse } from '../../../constant/api';
import { api } from '../../../utils/api';

interface MessageBoxClickRequest {
  messageBoxId: number;
  historyId: string;
  isBulk: boolean;
}

const messageBoxClick = ({
  messageBoxId,
  historyId,
  isBulk,
}: MessageBoxClickRequest) => {
  if (isBulk) {
    return api.post<ApiResponse<undefined>>('/v2/viewer/submit/messageBox', {
      historyId,
      messageBoxId,
    });
  }
  return api.post<ApiResponse<undefined>>('/file/action/messagebox', {
    messageBoxId,
    historyId,
    isBulk,
  });
};

const useMessageBoxClick = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    MessageBoxClickRequest,
    QueryKey
  >,
) => {
  return useMutation(messageBoxClick, {
    ...options,
  });
};

export default useMessageBoxClick;
